import React from "react";
import AdmVisitorList from "../../components/AdminTabs/AdminVisitorsList/AdmVisitorList";

const DayBook = () => {
  return (
    <div>
      <AdmVisitorList />
    </div>
  );
};

export default DayBook;
